import { bool, number, shape, string } from 'prop-types'

export const userDataType = shape({
  cartItems: number,
  isLoggedIn: bool,
  user: shape({
    code: string,
    firstName: string,
    lastName: string,
    email: string,
  }),
})
